module.exports = __webpack_public_path__ + "static/media/close-icon.3fcc47fb.svg";